module.exports = __webpack_public_path__ + "static/media/4.687e829c.jpg";